import { render, staticRenderFns } from "./staff-form.vue?vue&type=template&id=257bef89&"
import script from "./staff-form.vue?vue&type=script&lang=js&"
export * from "./staff-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports